<template>
    <div class="email-preview-text" v-html="value"></div>
</template>

<script>
export default {
    props: {text: String},
    data() {
        return {
        }
    },
    computed: {
        value() {
            //解决样式冲突,可以优化为自定义私有方式，例如name
            let text = this.text;
            //禁用base标签
            if(text.indexOf('<base')){
                let req1 = new RegExp('<base','g');
                text = text.replace(req1,'<base href=""');
                isHave = true;
            }
            //如果正文存在样式，则规定私有
            let isHave = false;
            if(text.indexOf('<style type=text/css>')){
                let req1 = new RegExp('<style type=text/css>','g');
                text = text.replace(req1,'<style type=text/css scoped>.email-preview-text{');
                isHave = true;
            }
            if(text.indexOf('<style type="text/css">')){
                let req2 = new RegExp('<style type="text/css">','g');
                text = text.replace(req2,'<style type="text/css" scoped>.email-preview-text{');
                isHave = true;
            }
            if(text.indexOf('<style>')){
                let req3 = new RegExp('<style>','g');
                text = text.replace(req3,'<style scoped>.email-preview-text{');
                isHave = true;
            }
            if(isHave){
                let reqEnd = new RegExp('</style>','g');
                text = text.replace(reqEnd,'}</style>');
            }
            return text;
        }
    },
    watch: {
    },
}
</script>
<style>
.email-preview-text .content {
    box-sizing: unset;
    border: unset;
    background-color: unset;
    position: unset;
    margin: unset;
    z-index: unset;
    bottom: unset;
    right: unset;
    left: unset;
    top: unset;
}

.email-preview-text img {
    border: unset;
    vertical-align: unset;
    display: unset;
    max-width: unset;
    height: unset;
}

.email-preview-text .logo {
    width: unset;
    height: unset;
    margin: unset;
    background-image: unset;
}

.email-preview-text .copy {
    width: unset;
    height: unset;
    background-image: unset;
}
</style>


// WEBPACK FOOTER //
// src/components/preview/email_text.vue